import { ApolloLink } from '@apollo/client';
import useAccessTokenStore from 'auth/lib/useAccessTokenStore';

export const authLink = new ApolloLink((operation, forward) => {
	operation.setContext(({ headers = {} }) => ({
		headers: {
			...headers,
			authorization: `Bearer ${useAccessTokenStore.getState().accessToken || null}`,
		},
	}));

	return forward(operation);
});
